'use strict';

import { base, Component, PropTypes, update, sub, fromJS, mq, redirect } from 'core';

import { Button, ButtonToolbar, ListGroup, ListGroupItem, Grid, Row, Col, Input, Panel } from 'react-bootstrap';

import Avatar               from 'material-ui/lib/avatar';
import FontIcon             from 'material-ui/lib/font-icon';
import IconButton           from 'material-ui/lib/icon-button';
import TextField            from 'material-ui/lib/text-field';
import DropDownMenu         from 'material-ui/lib/drop-down-menu';
import IconMenu             from 'material-ui/lib/menus/icon-menu';
import Menu                 from 'material-ui/lib/menus/menu';
import MenuItem             from 'material-ui/lib/menus/menu-item';
import MenuDivider          from 'material-ui/lib/menus/menu-divider';
import FlatButton           from 'material-ui/lib/flat-button';
import LeftNav              from 'material-ui/lib/left-nav';

import $style from './style.styl';

import updateCards from 'a/cards/update';

class InlineTextField extends Component {

    styles = {
        style: { height: 36 },
        floatingLabelStyle: { top: 6 },
        inputStyle: {
            marginTop: 0,
            fontWeight: 400
        },
        underlineStyle: {
            bottom: 4,
            borderRadius: 50,
            border: '1px solid #f0f0f0',
            background: '#f0f0f0',
            borderWidth: '1px 0 1px',
            padding: '14px 0',
            marginLeft: -12,
            zIndex: -1
        },
        underlineFocusStyle: {
            bottom: 4,
            borderWidth: '0 0 1px',
            transformOrigin: '25% 50% 0'
        },
        underlineDisabledStyle: { bottom: 4 }
    }

    render() {

        return <TextField {..._.merge(this.styles, this.props)} />
    }
}

@base({
    styles: [ $style ],
    track: [['locale']]
})
class Header extends Component {

    styles = {
        app_name: {
            fontFamily: 'Playfair Display, serif',
            fontWeight: 'bold',
            textRendering: 'optimizeLegibility',
            fontSize: '50px',
            position: 'relative',
            top: '-5px',
            marginRight: 40,
            float: 'left'
        },
        actionIcons: {
            padding: '0',
            height: 0,
            top: 4
        },
        icon: {
            tooltipPosition: 'bottom-right',
            tooltipStyles: {
                top: 25
            },
            iconStyle: {
                fontSize: 18,
                background: '#999',
                borderRadius: '50%',
                width: 30, height: 30,
                color: 'white',
                padding: '5px 2px 0'
            }
        }
    }

    toggleLocale = (locale) => {

        this._set('locale', locale);

        updateCards();
    }

 	render() {

        const { edit, toolbar } = this.props;
        const locale = this._get('locale');

        const random32 = (function b(a){return a?(a^Math.random()*10>>a/4).toString(10):([1e15]+1e15).replace(/[018]/g,b)})();

        const sitesStatus = [
            { payload: -1, text: 'Dia a dia' },
            { payload: 'open', text: 'Garçom' },
            { payload: 'occupied', text: 'Cozinha' },
            { payload: 'reseved', text: 'Caixa' },
        ];

        const caretTrigger = label =>
            <FlatButton style={{ top: 15, marginRight: 5 }}>
                <span style={{ fontSize: 17, fontWeight: 400, paddingLeft: 10, textTransform: 'initial' }}>
                    {label}
                </span>
                <FontIcon className="icon-caret_o_down"
                          iconStyle={{ fontSize: 18 }} style={{ top: 5 }} />
             </FlatButton>;

        const navMenu = (locale && locale == 'En') ? [
            { link: '/home', text: 'Home' },
            { link: '/about', text: 'About' },
            { link: '/products', text: 'Products and services' },
            { link: '/cases', text: 'Customers' },
            { link: '/contact', text: 'Contact' },
            { text: 'Accede - Equipamentos Industriais' },
            { text: '+55 (11) 4398-7300' },
        ] : [
            { link: '/home', text: 'Home' },
            { link: '/about', text: 'Sobre a Accede' },
            { link: '/products', text: 'Produtos e serviços' },
            { link: '/cases', text: 'Clientes' },
            { link: '/contact', text: 'Mais informações' },
            { link: '/contact', text: 'Contato' },
            { text: 'Accede - Equipamentos Industriais' },
            { text: '(11) 4398-7300' },
        ];

        const Locale = (locale && locale == 'En')
            ? ({ label: 'Português', key: 'Pt' })
            : ({ label: 'English', key: 'En' });

  		return (
            <div className="header header-toolbar" style={{ borderTop: '5px solid #eaeaea', paddingTop: 3 }}>
                <span>
                    {/*<img className="header-logo" src="/media/logo.png" alt="Logo Accede Automação Industrial"/>*/}
                </span>
                <span style={{ position: 'fixed', right: 10, top: 13, textAlign: 'right' }}>
                    <span onTouchTap={() => this.toggleLocale(Locale.key)}
                          style={{ fontWeight: 'bold', textShadow: '0 0 1px white', color: '#222', cursor: 'pointer' }}>
                        {Locale.label}
                    </span>
                </span>
                <span style={{ position: 'fixed', left: 5, top: 13 }}>
                    <i style={{ fontSize: 24 }} className="icon-bars"
                       onTouchTap={() => this.refs.leftNav.toggle()}/>
                </span>
                <LeftNav ref="leftNav" docked={false} menuItems={navMenu}
                         onChange={(e, i, { link }) => link && redirect(link)}/>
            </div>
  		);
	}
};

export default Header



// WEBPACK FOOTER //
// ./ui/c/header/index.jsx